<div class="row flex wrap pad-top-20 find-a-shop">
  <ol id="results" class="column twelve">
    @for (shop of pagedItems; track shop; let i = $index) {
      <li
        #card
        id="results-list"
        class="neutral-200-border"
        (click)="selectShop(shop)"
        [ngClass]="{ selected: selectedShop === shop }"
      >
        <drp-shop-card
          data-cy="drpShopResultCard"
          [isPartner]="isPartner"
          [shop]="shop"
          [index]="i + 1"
        ></drp-shop-card>
      </li>
    }
  </ol>
</div>

<div class="pager pad-top-20">
  @if (pager.pages && pager.pages.length) {
    <div>
      <div class="row">
        <div class="column sm-three text-left hidden">
          <span [style.visibility]="pager.currentPage !== 1 ? 'visible' : 'hidden'">
            <a (click)="handlePagination(1)"><span class="pad-right-10"> <<</span> </a>
            <a (click)="handlePagination(pager.currentPage - 1)"><span>Prev</span></a>
          </span>
        </div>
        <div class="column sm-six text-center">
          @for (page of pager.pages; track page) {
            <span class="pg-number" [ngClass]="{ active: pager.currentPage === page }">
              <a (click)="handlePagination(page)">{{ page }}</a>
            </span>
          }
        </div>
        <div class="column sm-three text-right">
          <span [style.visibility]="pager.currentPage !== pager.totalPages ? 'visible' : 'hidden'">
            <a (click)="handlePagination(pager.currentPage + 1)"><span>Next</span></a>
            <a (click)="handlePagination(pager.totalPages)"><span class="pad-left-10">>></span></a>
          </span>
        </div>
      </div>
    </div>
  }
  <div class="row" [style.visibility]="shopSearchResults.length > 0 ? 'visible' : 'hidden'">
    <div class="column twelve text-center">
      <span class="total"
        >showing {{ getFirstOfPg() }} of {{ getLastOfPg() }} -
        {{ shopSearchResults.length }} results</span
      >
    </div>
  </div>
</div>
